var _defs, _g, _rect, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmationPopupGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14275",
    "data-name": "Group 14275",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270.63,
    height: 162.508,
    viewBox: "0 0 270.63 162.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e3434"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.099,
    cy: 0.698,
    r: 1.307,
    gradientTransform: "translate(0.125) scale(0.75 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7c759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f79239"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.15,
    cy: 0.185,
    r: 1.217,
    gradientTransform: "translate(0.227) scale(0.547 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.531,
    cy: 0.097,
    r: 0.626,
    gradientTransform: "translate(-0.081) scale(1.162 1)",
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5194",
    "data-name": "Path 5194",
    d: "M404.667,462.374c-.09.394-.169.775-.27,1.169a66.212,66.212,0,0,1-9.071,20.189l-23.135-.072h-1.217l-124.81-.37H244.71l-24.182-.072-1.566-.012-76.806-.227s-19.946-24.858,6.761-48.115c12.519-10.889,29.343-9.205,42.154-10.614.553-.071,1.1-.13,1.646-.214,13.579-1.875,21.951-8.263,14.232-39.6a44.516,44.516,0,0,1-1.239-12.907c.022-.6.067-1.194.124-1.79,2.558-29.084,32.655-54.192,67.34-39.328.631.263,1.262.549,1.893.847a82.515,82.515,0,0,1,23.348,17.05c6.547,6.614,12.249,12.595,17.308,18.027.574.622,1.138,1.23,1.7,1.839,24.363,26.362,32.769,39.124,45.785,46.622.349.191.686.394,1.047.585a62,62,0,0,0,13.038,5.135,47.333,47.333,0,0,1,14.288,6.554q.508.359.98.717C403.078,435.63,407.822,447.712,404.667,462.374Z",
    transform: "translate(-135 -326)",
    fill: "#9981ab",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5195",
    "data-name": "Path 5195",
    d: "M326.309,345.745c-20.245-16.3-46.529-12.475-41.243,0s28.14,44.609,44.322,38.989S339.728,356.552,326.309,345.745Z",
    transform: "translate(-92.005 -323.436)",
    fill: "#9981ab",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5196",
    "data-name": "Path 5196",
    d: "M361.682,426.8c-17.2,14.625-32.689,21.991-46.291,21.991a35.2,35.2,0,0,1-9.86-1.384c-20.35-5.921-35.744-30.767-45.738-73.82-4.429-19.138-10.728-33.464-17.5-44.162.631.263,1.262.549,1.893.847,6.457,10.637,12.429,24.643,16.7,43.029,9.894,42.61,25.017,67.156,44.94,72.959,15.4,4.476,33.805-2.3,54.877-20.178Q361.21,426.443,361.682,426.8Z",
    transform: "translate(-104.118 -325.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5197",
    "data-name": "Path 5197",
    d: "M323.866,406.367q-7.775,8.005-15.043,8.023a13.192,13.192,0,0,1-3.257-.417c-14.524-3.726-24.305-31.687-30.233-56.651.574.622,1.138,1.23,1.7,1.839,5.928,24.106,15.348,50.2,28.8,53.655,5.342,1.36,11.033-.992,16.983-7.033C323.168,405.973,323.505,406.176,323.866,406.367Z",
    transform: "translate(-94.609 -316.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5198",
    "data-name": "Path 5198",
    d: "M230.36,473.516h-1.454c9.387-12.237,14.075-25.359,13.771-38.921-.564-25.084-18.018-46.479-35.079-56.556a58.674,58.674,0,0,1-17.691-16.285c.022-.6.067-1.194.124-1.79A57.819,57.819,0,0,0,208.15,377c17.33,10.243,35.079,32.009,35.653,57.57C244.041,445.1,241.325,458.855,230.36,473.516Z",
    transform: "translate(-119.196 -316.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5199",
    "data-name": "Path 5199",
    d: "M208,461.308l-1.566-.012c5.713-7.151,9.42-15.079,9.183-22.851-.316-10.315-7.335-18.983-20.858-25.753a97.084,97.084,0,0,1-16.216-10.352c.553-.071,1.1-.13,1.646-.214a95.443,95.443,0,0,0,15.055,9.48c13.939,6.984,21.173,16,21.5,26.791C216.988,446.468,213.394,454.335,208,461.308Z",
    transform: "translate(-122.468 -304.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5200",
    "data-name": "Path 5200",
    d: "M351.927,431.937c-.09.394-.169.775-.27,1.169-8.362-.739-15.438.992-21.151,5.194-5.172,3.8-8.676,9.241-11.055,14.923h-1.217c2.445-6.017,6.12-11.854,11.629-15.9C335.836,432.928,343.228,431.125,351.927,431.937Z",
    transform: "translate(-82.261 -295.563)",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 268.481,
    height: 5.394,
    transform: "translate(1.288 157.115)",
    fill: "#89729b"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047",
    transform: "translate(194.246 77.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5201",
    "data-name": "Path 5201",
    d: "M297.366,444.892s3.724-4.537,1.862-9.191c-1.167-2.917-3.141-2.792-7.446-8.028s-8.028-18.268,5.584-16.173,17.454.232,15.01-3.374-10.713-8.959-7.509-16.057,15.538-4.654,27.522-3.607,8.028-4.189,15.359-.7,7.33,23.5-9.541,22.223-20.012-.384-19.314,5.8,3.606,16.773-7.33,12.758-7.938,1.193-5.934,5.5c2.56,5.5-3.723,10.85-3.723,10.85Z",
    transform: "translate(-285.255 -386.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5202",
    "data-name": "Path 5202",
    d: "M296.664,394.958c-3.554-.711-7.33-6.515-10.355-1.4-2.439,4.126,5,10.24,10.7,7.8C301.525,399.423,301.317,395.889,296.664,394.958Z",
    transform: "translate(-285.832 -385.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5203",
    "data-name": "Path 5203",
    d: "M306.891,450.356v-2.792a8.232,8.232,0,0,0,7.872-5.923l.471-1.628a3.266,3.266,0,0,0-3.137-4.17h-2.182v-2.792H312.1a6.059,6.059,0,0,1,5.82,7.737l-.471,1.628A11.037,11.037,0,0,1,306.891,450.356Z",
    transform: "translate(-279.771 -373.161)",
    fill: "#89729b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5204",
    "data-name": "Path 5204",
    d: "M316.022,432.584l-.4,2.806-2.108,14.522a4.613,4.613,0,0,1-4.552,3.951h-10.4A4.59,4.59,0,0,1,294,449.9l-2.039-14.507-.392-2.82a2.448,2.448,0,0,1,2.43-2.792h19.589A2.458,2.458,0,0,1,316.022,432.584Z",
    transform: "translate(-284.187 -374.104)",
    fill: "#5a4b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5205",
    "data-name": "Path 5205",
    d: "M316.022,432.584l-.4,2.806H291.965l-.392-2.82a2.448,2.448,0,0,1,2.43-2.792h19.589A2.458,2.458,0,0,1,316.022,432.584Z",
    transform: "translate(-284.187 -374.104)",
    fill: "#89729b"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4053",
    "data-name": "Group 4053",
    transform: "translate(58.99 18.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    "data-name": "Group 4048",
    transform: "translate(21.802 54.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5206",
    "data-name": "Path 5206",
    d: "M281.829,455.87s3.292-2.495,2.094-13.787-2.094-19.285-2.094-19.285l-24.7,2.7,2.793,22.6Z",
    transform: "translate(-180.639 -371.485)",
    fill: "#f29c8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5207",
    "data-name": "Path 5207",
    d: "M277.317,442.736l3.281,24.6H199.618s-8.028-59.814,9.075-73.622c7.5-6.061,17.075-8.8,25.44-9.969h.027a83.14,83.14,0,0,1,19.45-.42s2.024-.013,5.124.265c6.967.614,19.393,2.639,26.751,9.4,10.64,9.773,15.526,49.049,15.526,49.049S291.656,444.132,277.317,442.736Z",
    transform: "translate(-197.735 -382.953)",
    fill: "#f5ba00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5208",
    "data-name": "Path 5208",
    d: "M276.321,436.2l-3.7-.524-11.518-30.019s.4,34-10.331,44.109-37.723,5.225-37.723,5.225l-3.775-49.334-8.093,25.257,5.352,29.894h73.069Z",
    transform: "translate(-196.742 -376.419)",
    fill: "#daa603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5209",
    "data-name": "Path 5209",
    d: "M251.849,383.592c-.726,6.787-2.722,16.671-8.322,20.734-8.908,6.451-17.02,3.757-20.51-2.876s.7-16.224,1.829-17.02l2.4-.684h.027a83.14,83.14,0,0,1,19.45-.42S248.749,383.314,251.849,383.592Z",
    transform: "translate(-190.851 -382.953)",
    fill: "#daa603"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4049",
    "data-name": "Group 4049",
    transform: "translate(0 70.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5210",
    "data-name": "Path 5210",
    d: "M204.49,457.1H192.736a11.927,11.927,0,0,1-11.687-14.306l4.941-24.264Z",
    transform: "translate(-180.806 -388.436)",
    fill: "#f29c8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5211",
    "data-name": "Path 5211",
    d: "M202.188,418.063s1.84-3.968,0-5.626a6.339,6.339,0,0,0-4.109-1.57s-1.135-3.928-8.2-3.23-7.745,7.324-3.785,10.469Z",
    transform: "translate(-179.979 -391.595)",
    fill: "#feb19e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5212",
    "data-name": "Path 5212",
    d: "M197.067,417.313l-7.887-20.977a1.809,1.809,0,0,0-2.164-1.111h0a1.811,1.811,0,0,0-1.2,2.44l8.375,20.259Z",
    transform: "translate(-179.404 -395.162)",
    fill: "#525559"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4050",
    "data-name": "Group 4050",
    transform: "translate(13.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5213",
    "data-name": "Path 5213",
    d: "M247.612,366.7s.7-11.955-2.355-15.706-6.318-2.357-6.318-2.357.035-5.759-7.383-7.418a24.535,24.535,0,0,0-22.077,5.585c-6.283,5.759-15.534,2.766-15.534,6.837s5.759,5.584,5.759,5.584-7.941-.554-8.027,2.938,5.672,9.6,13.438,9.424c0,0,1.745,11.432,12.914,11.083l16.93-5.847,11.257-5.934Z",
    transform: "translate(-191.675 -340.583)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5214",
    "data-name": "Path 5214",
    d: "M246.87,387.715s-2.506,22.315-14.437,20.832c-6.613-.822-7.038-6.645-6.465-10.443a18.417,18.417,0,0,1,1.117-4.218l-5.934-8.265,16.755-17.914C240.531,376.168,243.407,383.4,246.87,387.715Z",
    transform: "translate(-183.191 -332.776)",
    fill: "#feb19e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5215",
    "data-name": "Path 5215",
    d: "M225.969,398.1a18.417,18.417,0,0,1,1.117-4.218l-5.934-8.265,16.755-17.914C244.44,391.066,232.042,396.735,225.969,398.1Z",
    transform: "translate(-183.191 -332.776)",
    fill: "#ff856a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5216",
    "data-name": "Path 5216",
    d: "M206.244,368.555s12.06,26.684,24.667,25.714c10.587-.815,13.9-18.21,11.285-22.922,0,0,4.714.437,3.665-5.061s-6.2-11-7.155,0c0,0-6.166,2.036-8.144-11.227,0,0-6.05,9.889-10.589,11.053s-3.258-3.374-3.258-3.374S213.923,367.159,206.244,368.555Z",
    transform: "translate(-187.482 -336.416)",
    fill: "#feb19e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4052",
    "data-name": "Group 4052",
    transform: "translate(3.03 96.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4051",
    "data-name": "Group 4051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5217",
    "data-name": "Path 5217",
    d: "M245.308,457.908H200.518a3.623,3.623,0,0,1-3.365-2.29l-1.451-3.686-12.287-31.276a3.615,3.615,0,0,1,3.365-4.943h44.274a3.634,3.634,0,0,1,3.351,2.249l14.255,34.962A3.614,3.614,0,0,1,245.308,457.908Z",
    transform: "translate(-183.158 -415.714)",
    fill: "#1b3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5218",
    "data-name": "Path 5218",
    d: "M242.153,457.908H200.518a3.623,3.623,0,0,1-3.365-2.29l-1.451-3.686-12.287-31.276a3.615,3.615,0,0,1,3.365-4.943H227.9a3.4,3.4,0,0,1,1.061.167,3.6,3.6,0,0,1,2.29,2.081L245.5,452.924A3.62,3.62,0,0,1,242.153,457.908Z",
    transform: "translate(-183.158 -415.714)",
    fill: "#23406d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5219",
    "data-name": "Path 5219",
    d: "M210.943,431.47c.769,2.693-.035,5.283-1.8,5.785s-3.812-1.272-4.58-3.964.035-5.281,1.8-5.785S210.175,428.778,210.943,431.47Z",
    transform: "translate(-177.08 -412.344)",
    fill: "#4e79b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5220",
    "data-name": "Path 5220",
    d: "M242.505,457.908H197.714a3.623,3.623,0,0,1-3.365-2.29l-1.451-3.686c22.116-2.3,30.479-24.993,33.258-36.052l.041-.167h2.053a3.634,3.634,0,0,1,3.351,2.249l14.255,34.962A3.614,3.614,0,0,1,242.505,457.908Z",
    transform: "translate(-180.355 -415.714)",
    fill: "#1b3151",
    opacity: 0.49
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5221",
    "data-name": "Path 5221",
    d: "M295.885,457.1s-5.062-19.373-55.675-29.146c0,0-3.839-8.9-11.867-9.424l1.221,5.584a60.667,60.667,0,0,1-17.19.786c-8.291-1.047-2.269,7.418,3.316,11.607s6.719,6.806,15.271,4.974S241.52,439.3,241.52,439.3s10.908,11.518,22.95,17.8Z",
    transform: "translate(-175.924 -414.904)",
    fill: "#feb19e"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054",
    transform: "translate(1.01 39.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5222",
    "data-name": "Path 5222",
    d: "M182.088,407.189a11.147,11.147,0,0,0-7.912,5.7c-3.025,5.235-5.585,8.376-10.589,6.98s-4.305-11.984,3.607-15.01C175,401.88,182.088,407.189,182.088,407.189Z",
    transform: "translate(-128.696 -343.308)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5223",
    "data-name": "Path 5223",
    d: "M191.851,402.016s-8.027-10.923-20.943-6.967-25.016,5.119-32.113-6.981-.233-17.453,6.05-16.637,11.867,12.1,21.06,12.216S189.874,390.831,191.851,402.016Z",
    transform: "translate(-135.784 -352.692)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5224",
    "data-name": "Path 5224",
    d: "M251.783,380.835s-3.374-16.986,8.959-22.689,14.892,9.308,5.817,11.344S252.6,376.065,251.783,380.835Z",
    transform: "translate(-102.518 -356.862)",
    fill: "url(#radial-gradient-3)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationPopupGraphic);
export default __webpack_public_path__ + "static/media/confirmation-popup-graphic.9f83ec8ea6258cae30e16f6c4c6b8cc3.svg";
export { ForwardRef as ReactComponent };